import vars from '../helpers';
import {actualYear} from './actualYear';
import player from './player';

const links = document.querySelectorAll('[href*="#"]');
const headerNav = vars.header.querySelector('.header__nav');
const headerBurger = vars.header.querySelector('.header__burger');
const elementFade = document.querySelectorAll('[data-animate]');
const selectButton = document.querySelectorAll('.profile__option button');
const accordionQuestion = document.querySelectorAll('.profile__accordion-question');
const animateTlNav = gsap.timeline();
const animateDuration = 0.3;
let animateFlag = true;

const scrollTo = (current) => {
	gsap.to(window, {
		delay: 0.15,
		duration: 0.7,
		scrollTo: current,
		ease: 'Power1.easeInOut',
	});
};

const animateMouse = (e, element) => {
	gsap.to(element, {
		css: {
			left: e.pageX,
			top: e.pageY,
		},
		duration: animateDuration,
	});
};

const animateNavOpen = () => {
	animateTlNav.from(headerNav, {
		onStart() {
			vars.html.classList.add('no-scroll');
			vars.header.classList.add('is-nav');
		},
		duration: animateDuration,
		x: '-100%',
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateNavClose = (event) => {
	animateTlNav.to(headerNav, {
		onComplete() {
			vars.html.classList.remove('no-scroll');
			vars.header.classList.remove('is-nav');
		},
		duration: event === 'resize' ? 0 : animateDuration,
		x: event === 'resize' ? '0' : '-100%',
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateFade = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration * 2,
		delay: elementDelay ? elementDelay : 0.1,
		opacity: 1,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateFadeDown = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration * 2,
		delay: elementDelay ? elementDelay : 0.2,
		opacity: 1,
		y: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const observeInit = () => {
	const observers = new IntersectionObserver((entries, observer) => {
		entries.forEach((element) => {
			if (element.isIntersecting && animateFlag) {
				observer.unobserve(element.target);

				if (element.target.dataset.animate === 'fade') {
					animateFade(element.target);
				}

				if (element.target.dataset.animate === 'fade-down') {
					animateFadeDown(element.target);
				}
			}
		});
	}, {threshold: 0.3});

	elementFade.forEach((element) => {
		observers.observe(element);
	});
};

const eventInit = () => {
	headerBurger.addEventListener('click', () => {
		if (vars.header.classList.contains('is-nav')) {
			animateNavClose();
		} else {
			animateNavOpen();
		}
	});

	window.addEventListener('resize', () => {
		if (!vars.isMobile() && vars.header.classList.contains('is-nav')) {
			animateNavClose('resize');
		}
	});

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			scrollTo(`#${link.getAttribute('href').split('#')[1]}`);

			if (vars.header.classList.contains('is-nav')) {
				animateNavClose();
			}
		});
	});

	if (vars.html.classList.contains('page-profile')) {
		accordionQuestion.forEach((question) => {
			question.addEventListener('click', (e) => {
				const line = e.target.closest('.profile__accordion-line');
				const responsion = line.querySelector('.profile__accordion-responsion');
				const responsionHeight = line.querySelector('.profile__accordion-content').clientHeight;

				if (line.classList.contains('is-active')) {
					line.classList.remove('is-active');
					responsion.style.height = 0;
				} else {
					line.classList.add('is-active');
					responsion.style.height = `${responsionHeight}px`;
				}
			});
		});

		selectButton.forEach((button) => {
			button.addEventListener('click', (e) => {
				const target = e.target;
				const parrent = target.closest('.profile__data');
				const num = target.dataset.button;
				const active = parrent.querySelector('.button.is-select');
				const activeNum = active.dataset.button;
				const tabCurrent = parrent.querySelector(`[data-tab="${num}"]`);
				const tabActive = parrent.querySelector(`[data-tab="${activeNum}"]`);

				gsap.timeline().to(tabActive, {
					onStart() {
						active.classList.remove('is-select');
						target.classList.add('is-select');
					},
					onComplete() {
						tabActive.classList.add('is-hidden');
						tabCurrent.classList.remove('is-hidden');
					},
					duration: animateDuration,
					opacity: 0,
					ease: 'Power1.easeOut',
					clearProps: 'all',
				}).from(tabCurrent, {
					duration: animateDuration,
					opacity: 0,
					ease: 'Power1.easeOut',
					clearProps: 'all',
				});
			});
		});
	}
};

const langMenuOpen = () => {
	const langMenu = document.querySelector('.header__lang-menu');

	document.querySelector('body').addEventListener('click', (e) => {
		if (!e.target.closest('.header__lang-menu') && !e.target.closest('.header__lang')) {
			langMenu.classList.remove('active');
		}
	});

	document.querySelector('.header__lang').addEventListener('click', () => {
		langMenu.classList.toggle('active');
	});
};

const init = () => {
	observeInit();
	eventInit();
	langMenuOpen();
	actualYear();
	player.init();
};

export default {
	init,
};
